import React from 'react';

const EXPERIENCE_ITEMS = [
  {
    date: 'OCT 2024 - PRESENT',
    title: 'Senior Software Engineer',
    company: 'MARKOPOLO AI INC',
    points: [
      'Leading the development of an AI automation platform enabling Autonomous Revenue Agents that drive sales through personalized email, SMS, WhatsApp, and voice campaigns.',
      'Built and optimized real-time campaign pipelines and data sync layers, achieving 99.9% uptime across channels.',
      'Engineered MarkTag, a cookieless first-party tracking system with lifetime attribution, boosting data accuracy by 40% while maintaining full GDPR/CCPA compliance.',
      'Improved backend and frontend performance by 35%, enhancing overall responsiveness and scalability.',
      'Delivered a centralized analytics dashboard with real-time insights and white-label reporting for clients.',
      'Mentored junior developers and drove clean architecture practices, increasing team productivity by 25%.',
    ],
  },
  {
    date: 'JUL 2022 - SEP 2024',
    title: 'Software Engineer',
    company: 'MARKOPOLO AI INC',
    points: [
      'Optimized a web application to load 2x faster, resulting in a 10% increase in user satisfaction.',
      'Implemented 50+ features and functionalities, ensuring compatibility with 99% of browsers and accessibility for all users.',
      'Dedicated efforts to optimizing web applications, resulting in a 20% improvement in page load times and an overall 98% user satisfaction rate.',
      'Proactively identified and resolved 100+ technical issues, reducing downtime by 50%.',
      'Actively participated in code and design reviews, contributing valuable feedback that led to a 90% increase in project quality and efficiency.',
      'Provided mentorship and support to junior front-end developers, resulting in a 30% improvement in their skill development and productivity.',
    ],
  },
  {
    date: 'SEP 2021 - JUN 2022',
    title: 'Web Developer',
    company: 'CHAYA APP LIMITED',
    points: [
      'Implemented, built, and deployed 2 web applications from scratch to production.',
      'Supervised the production and developed highly available serverless technology, testing customer-facing prototypes before deployment and scaling for thousands of concurrent users.',
      'Tested customer-facing prototypes before deployment, resulting in a 99% success rate.',
      'Increased web page speed by 2x, making websites more user-friendly and accessible.',
      'Made websites compatible with 99% of browsers, ensuring a seamless experience for all users.',
      'Increased mobile traffic by 20% with a mobile-first responsive website approach.',
    ],
  },
];

const Experiences = () => {
  return (
    <section className='experiences' data-aos='zoom-in'>
      <div className='container'>
        <div className='common mt-5'>
          <h2 className='mainHeader'>Working Experiences</h2>
          <div className='commonBorder' />
        </div>

        <div className='exp-timeline'>
          {EXPERIENCE_ITEMS.map((item, index) => (
            <div
              className='exp-item'
              key={item.title + item.date}
              data-aos='fade-up'
              data-aos-duration='700'
              data-aos-delay={index * 150}
            >
              <span className='exp-date'>{item.date}</span>
              <h4 className='exp-title'>{item.title}</h4>
              <p className='exp-company'>{item.company}</p>
              <ul className='exp-bullets'>
                {item.points.map((point, pointIndex) => (
                  <li key={pointIndex}>{point}</li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Experiences;
